/**
 * Shared color palette for OTP, Video Consultation, and all pages.
 * Ensures consistent look across the app.
 */
export const theme = {
  // Middle content area - white (OTP cards, consultation area)
  pageBg: '#ffffff',
  // Header & Footer - very light pink (#fdf2f5)
  headerFooterBg: '#fdf2f5',
  // Cards & content surfaces
  cardBg: '#ffffff',
  // Brand primary
  primary: '#962067',
  primaryLight: '#b82d7a',
  // Text
  textPrimary: '#444',
  textSecondary: '#888',
  textMuted: '#bbb',
  // Borders & dividers
  border: '#f0f0f0',
  borderLight: '#eee',
  // Button disabled
  disabled: '#b0b0b0',
};

export default theme;
